import { useCallback } from "react";
import { TiDelete } from "react-icons/ti";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { type UploadProgress } from "contexts/UploadContext/UploadContext";
import ProgressSpinner from "./ProgressSpinner";
import styles from "./UploadListItem.module.scss";
import { useUploadProgress } from "contexts/UploadContext";

interface UploadListItemProps {
  upload: UploadProgress;
}

/**
 * An in-progress or error'd upload.
 *
 * TODO: separate the in-progress and error states into separate components.
 */
export default function UploadListItem({ upload }: UploadListItemProps) {
  const { chatId, fileName, percentCompleted, status, errorMessage } = upload;
  const { removeUploadProgress } = useUploadProgress();

  const handleDismissError = useCallback(() => {
    removeUploadProgress({ chatId, fileName });
  }, [removeUploadProgress, chatId, fileName]);

  const headerText =
    status === "error" ? "Error uploading file" : "Uploading file";

  // maxWidth here is meant to make messages more readable on larger screens
  // Tachyon's `measure-wide` was too narrow.
  return (
    <div className="flex center measure-extra-wide">
      {/* Display picture */}
      <div className="mh2 mt2" style={{ alignSelf: "start" }}>
        <div style={{ width: "34px", height: "34px", position: "relative" }}>
          <div className={styles.uploadingFileCircle}>
            <FontAwesomeIcon icon={"file"} />
          </div>
          <div style={{ position: "absolute" }}>
            <ProgressSpinner percentage={percentCompleted} />
          </div>
        </div>
      </div>
      {/* File name and progress spinner */}
      <div
        className={
          status === "error"
            ? styles.uploadStatus + " " + styles.error
            : styles.uploadStatus + ` pv2 ph3 ml1-ns br3 ba bw05 `
        }
      >
        <div className="flex items-center">
          {headerText}: {fileName}
          {/* TODO: add a cancel pending uploading button */}
          <div style={{ opacity: status === "error" ? 1 : 0 }}>
            {/** HACK: the button size is affecting the height of the div
             *   so I'm just making it transparent instead of hiding it for pending uploads */}
            <button
              className="bg-transparent bn dim pointer pa0 pl2 gray"
              onClick={handleDismissError}
            >
              <TiDelete size={20} />
            </button>
          </div>
        </div>
        {status === "error" && errorMessage && <div>{errorMessage}</div>}
      </div>
    </div>
  );
}
